// extracted by mini-css-extract-plugin
module.exports = {"modal":"Select_modal__1guH7"};